import { Box, CircularProgress } from "@mui/material"
import React from "react"

const LoadingWidget = () => {
    return <Box sx={{width: "100%", display: "flex", justifyContent: "center"}}>
        <CircularProgress />
    </Box>
}

export default LoadingWidget;